// LARINO — theme interactions (mobile nav, gallery, FAQ, variants, real AJAX cart)

document.addEventListener('DOMContentLoaded', function () {

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = (window.Larino && window.Larino.routes) || { cartAdd: '/cart/add', cart: '/cart' };

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    var format = (window.Larino && window.Larino.moneyFormat) || '${{amount}}';
    var value = (Number(cents) / 100).toFixed(2);
    var withComma = value.replace('.', ',');
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma);
  }

  /* ---------- Mobile nav ---------- */
  var navToggle = document.getElementById('navToggle');
  var mainNav = document.getElementById('mainNav');
  var navScrim = document.getElementById('navScrim');

  function closeNav() {
    if (!navToggle || !mainNav || !navScrim) return;
    navToggle.setAttribute('aria-expanded', 'false');
    mainNav.classList.remove('is-open');
    navScrim.classList.remove('is-open');
  }

  if (navToggle && mainNav && navScrim) {
    navToggle.addEventListener('click', function () {
      var isOpen = mainNav.classList.toggle('is-open');
      navToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      navScrim.classList.toggle('is-open', isOpen);
    });

    navScrim.addEventListener('click', closeNav);
    mainNav.querySelectorAll('.nav-link').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });
  }

  /* ---------- Gallery thumbnail swap ---------- */
  document.querySelectorAll('.buy__gallery').forEach(function (gallery) {
    var mainImage = gallery.querySelector('[data-main-image]');
    var thumbs = gallery.querySelectorAll('.thumb');

    // Preload every full-size gallery image in the background so swaps are instant
    function preloadGallery() {
      thumbs.forEach(function (t) {
        var src = t.getAttribute('data-src');
        if (src) {
          var img = new Image();
          img.decoding = 'async';
          img.src = src;
        }
      });
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(preloadGallery, { timeout: 3000 });
    } else {
      window.setTimeout(preloadGallery, 800);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt');
        mainImage.src = src;
        if (alt) mainImage.alt = alt;

        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-selected', 'true');
      });
    });
  });

  /* ---------- FAQ accordion ---------- */
  document.querySelectorAll('.faq-item__q').forEach(function (question) {
    question.addEventListener('click', function () {
      var isOpen = question.getAttribute('aria-expanded') === 'true';
      question.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ---------- Variant pickers ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var buyBlock = picker.closest('[data-buy-block]');
    var jsonScript = buyBlock && buyBlock.querySelector('[data-product-json]');
    if (!jsonScript) return;

    var product;
    try {
      product = JSON.parse(jsonScript.textContent);
    } catch (err) {
      return;
    }

    var sectionId = buyBlock.getAttribute('data-section-id');
    var stickyBar = sectionId ? document.querySelector('.sticky-bar[data-section-id="' + sectionId + '"]') : null;
    var scopes = [buyBlock, stickyBar].filter(Boolean);
    var selects = picker.querySelectorAll('.variant-select');

    function currentOptions() {
      var opts = [];
      selects.forEach(function (select) { opts.push(select.value); });
      return opts;
    }

    function findVariant(options) {
      return product.variants.filter(function (variant) {
        return options.every(function (value, index) { return variant.options[index] === value; });
      })[0];
    }

    function applyVariant(variant) {
      if (!variant) return;

      scopes.forEach(function (scope) {
        var input = scope.querySelector('[data-variant-id-input]');
        if (input) input.value = variant.id;

        var priceNow = scope.querySelector('[data-price-now]');
        var priceWas = scope.querySelector('[data-price-was]');
        if (priceNow) priceNow.textContent = formatMoney(variant.price);
        if (priceWas) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceWas.textContent = formatMoney(variant.compare_at_price);
            priceWas.style.display = '';
          } else {
            priceWas.style.display = 'none';
          }
        }

        scope.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
          var label = btn.querySelector('[data-btn-label]');
          if (variant.available) {
            btn.removeAttribute('disabled');
            if (label) label.textContent = 'Add to Cart';
          } else {
            btn.setAttribute('disabled', 'disabled');
            if (label) label.textContent = 'Sold Out';
          }
        });
      });
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        applyVariant(findVariant(currentOptions()));
      });
    });
  });

  /* ---------- Real add-to-cart (Shopify AJAX Cart API) ---------- */
  function refreshCartCount() {
    fetch(routes.cart + '.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function showButtonState(button, text, revertText, isError) {
    if (!button) return;
    var label = button.querySelector('[data-btn-label]') || button;
    var original = revertText || label.textContent;
    label.textContent = text;
    if (!isError) button.classList.add('is-added');
    window.setTimeout(function () {
      label.textContent = original;
      button.classList.remove('is-added');
    }, 1500);
  }

  function addToCart(variantId, quantity, button) {
    fetch(routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) { return { ok: res.ok, data: data }; });
      })
      .then(function (result) {
        if (!result.ok) throw new Error(result.data.description || 'Could not add to cart');
        refreshCartCount();
        showButtonState(button, 'Added ✓', 'Add to Cart');
      })
      .catch(function () {
        showButtonState(button, 'Error — try again', 'Add to Cart', true);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var formData = new FormData(form);
    var variantId = formData.get('id');
    var quantity = formData.get('quantity') || 1;
    var button = e.submitter || form.querySelector('[data-add-to-cart]');

    addToCart(variantId, quantity, button);
  });

  /* ---------- Mock add-to-cart (no product connected yet) ---------- */
  var mockCount = 0;
  document.querySelectorAll('[data-mock-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      mockCount += 1;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = mockCount;
      });
      showButtonState(btn, 'Added ✓', 'Add to Cart');
    });
  });

  /* ---------- Sticky mobile add-to-cart bar ---------- */
  var stickyBar = document.getElementById('stickyBar');
  var buyBlock = document.getElementById('shop');

  if (stickyBar && buyBlock && 'IntersectionObserver' in window) {
    var scrollObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var pastBuyBlock = entry.boundingClientRect.top < 0 && !entry.isIntersecting;
        stickyBar.classList.toggle('is-visible', pastBuyBlock);
        stickyBar.setAttribute('aria-hidden', String(!pastBuyBlock));
      });
    }, { threshold: 0 });

    scrollObserver.observe(buyBlock);
  }

  /* ---------- Restrained scroll reveal ---------- */
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    var revealTargets = document.querySelectorAll(
      '.feature__media, .feature__content, .attention, .guarantee, .review-card, .desire__overlay'
    );

    revealTargets.forEach(function (el) { el.classList.add('reveal'); });

    var revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealTargets.forEach(function (el) { revealObserver.observe(el); });
  }

});
